/**
 * La version des CGU est une DATE ISO (`2026-09-11`) : c'est un identifiant,
 * pas un libelle. Elle est comparee au caractere pres (`terms_version !==
 * TERMS_VERSION` gouverne la modale d'acceptation), stockee dans deux tables
 * et triable telle quelle. On ne la stocke donc jamais autrement.
 *
 * A l'ecran en revanche elle se lit comme une date, dans la langue de celui
 * qui regarde — meme forme longue que « Derniere mise a jour » sur la page des
 * CGU, sans l'ambiguite de 11/09 contre 09/11.
 */
export function formatTermsVersion(version: string | null | undefined, locale: string): string {
  if (!version) return '';
  // `TERMS_VERSION` est une chaine libre cote serveur : si un jour elle ne
  // porte plus une date, on affiche ce qu'elle vaut plutot que d'inventer.
  const iso = /^(\d{4})-(\d{2})-(\d{2})$/.exec(version);
  if (!iso) return version;
  const date = new Date(Number(iso[1]), Number(iso[2]) - 1, Number(iso[3]));
  return new Intl.DateTimeFormat(locale, {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(date);
}
